import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sso-line",
  "use": "icon-sso-line-usage",
  "viewBox": "0 0 30 2",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 2\" id=\"icon-sso-line\"><path stroke=\"#89A4F1\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-dasharray=\"4 4\" d=\"M1 1h28\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol